import axios from 'axios';

export default {
    methods: {
        async pcpLista(d, ok, err) {
            try {
                let r = await axios.post('pcp/ord-prod/lista', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async pcpPacaGenera(d, ok, err) {
            try {
                let r = await axios.post('pcp/etiqueta/paca-genera', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async pcpPacaDatos(d, ok, err) {
            try {
                let r = await axios.post('pcp/etiqueta/paca-datos', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async pcpPacaDivide(d, ok, err) {
            try {
                let r = await axios.post('pcp/etiqueta/paca-divide', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async pcpStore(d, ok, err) {
            try {
                let r = await axios.post('pcp/ord-prod', d)
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async pcpUpdate(d, ok, err) {
            try {
                let r = await axios.put('pcp/ord-prod/' + d.id, d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async pcpDestroy(id, ok, err) {
            try {
                let r = await axios.delete('pcp/ord-prod/' + id);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async pcpRecursos(d, ok, err) {
            try {
                let r = await axios.post('pcp/ord-prod/recursos', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async pcpFallas(ok, err) {
            try {
                let r = await axios.post('pcp/reporte-falla/listado');
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/pcp.js